import { Injectable } from '@angular/core';
import { AllocationViewEndpoint } from '../../../constants';
import { API_URL } from '../../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../../common/utils';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import {
  CouplingPlanSearchCriteria,
  TrailerHandlingCouplingPlanModel,
} from '../../../models/allocation-register-uli-details/trailer-handling/register-uli-trailer-handling.model';

@Injectable({
  providedIn: 'root',
})
export class TrailerHandlingListService {
  constructor(private http: WrapperHttpService) {}

  getCouplingPlanList(
    hubId: number,
    searchCriteria: CouplingPlanSearchCriteria,
  ): Observable<TrailerHandlingCouplingPlanModel> {
    const url = `${API_URL}${AllocationViewEndpoint.SwapBody}${AllocationViewEndpoint.CouplingPlan}${
      AllocationViewEndpoint.Ulis
    }${AllocationViewEndpoint.Hubs}/${hubId}?${getQueryStringFromObject(searchCriteria)}`;
    return this.http.withLoading().get<TrailerHandlingCouplingPlanModel>(url);
  }
}
